module.exports = __webpack_public_path__ + "static/media/trains.e540f399.png";